import React from "react";
import Link from "@material-ui/core/Link";
import FontAwesome from "react-fontawesome";

// An omitted `visible` key means always shown; a key present but falsy hides the link,
// so a role flag that is still undefined during load never leaks a restricted destination.
const isVisible = (link) => ("visible" in link ? !!link.visible : true);

// Links are described by { id, label, icon, count, loading, visible, onClick } so
// destinations can be added or reordered without touching layout markup.
const QuickLinkList = ({ links, title }) => {
    const shown = links.filter(isVisible);

    return (
        <div className="quickLinkPanel">
            {title ? <div className="quickLinkPanelHeader AdvisorHeaderMessage">{title}</div> : null}
            <div className="quickLinkGrid">
                {shown.map((link) => (
                    <Link key={link.id} id={link.id} onClick={link.onClick} className="quickLinkCard">
                        <FontAwesome name={link.icon} className="quickLinkCardIcon" />
                        <span className="quickLinkCardLabel">{link.label}</span>
                        {link.loading ? (
                            <span className="quickLinkCardMeta">Loading...</span>
                        ) : link.count != null ? (
                            <span className="quickLinkCardCount">{link.count}</span>
                        ) : null}
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default QuickLinkList;
